import { DialogDescription, DialogHeader, DialogTitle } from 'components/ui';

import { VerifyBusinessForm } from './Form';

interface VerifyBusinessFormProps {
  onSuccess: () => void;
}

const ContactInfo: React.FC = () => (
  <div className="text-base-mutedForeground font-normal text-sm text-center">
    An Appcharge representative will contact you to verify your account and
    enable access to the production environment.
  </div>
);

const Header: React.FC = () => (
  <DialogHeader className="flex flex-col gap-1.5 text-center">
    <DialogTitle className="flex flex-col gap-1.5 text-center my-auto text-2xl">
      Verify Your Business
    </DialogTitle>
    <DialogDescription className="text-base-mutedForeground font-normal text-sm">
      Enter your contact information below to verify your account.
    </DialogDescription>
  </DialogHeader>
);

export const VerifyBusinessFormContainer: React.FC<VerifyBusinessFormProps> = ({
  onSuccess
}) => (
  <div className="flex flex-col gap-6 px-6 py-3 w-full">
    <Header />
    <VerifyBusinessForm onSuccess={onSuccess} />
    <ContactInfo />
  </div>
);
